import script from "./SlideVerify.vue?vue&type=script&setup=true&lang=js"
export * from "./SlideVerify.vue?vue&type=script&setup=true&lang=js"

import "./SlideVerify.vue?vue&type=style&index=0&id=4cd39b8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cd39b8e"]])

export default __exports__